import { Resources } from 'constants/resources';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { activateUsers, deactivateUsers } from 'config/requests/users';
import { queryClient } from 'providers/queryClient';
import { BulkActionsToolbar, Identifier, useListContext, useNotify } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';
import { getId } from 'utils';

export const UsersListBulkActionsToolbar: React.FC = () => {
  const { selectedIds } = useListContext();
  const notify = useNotify();

  const handleClick = async (callback: (userIds?: Identifier[]) => Promise<unknown>) => {
    try {
      await callback(selectedIds?.map((id) => Number(getId(id))));
      await queryClient.invalidateQueries({ queryKey: [Resources.Users] });
      notify('Данные успешно обновлены', { type: 'success' });
    } catch (e: unknown) {
      notify('Ошибка обновления данных', { type: 'error' });
    }
  };

  return (
    <BulkActionsToolbar selectAllButton={false}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Button
          label="Активировать"
          onClick={() => handleClick(activateUsers)}
          startIcon={<AddCircleOutlineIcon />}
          sx={{
            marginRight: '8px',
          }}
        />
        <Button
          color="error"
          label="Деактивировать"
          onClick={() => handleClick(deactivateUsers)}
          startIcon={<RemoveCircleOutlineIcon />}
        />
      </Box>
    </BulkActionsToolbar>
  );
};
